import React, { useMemo } from 'react';
import { Radio } from 'tea-component';
import { getLocale, useIntl } from 'umi';
import { LANGUAGE_EN } from '@home/_config/config';
import { getName } from '@home/utils/common';
import SingleSelect from '@home/components/SingleSelect';
import './index.scss';

const compareOptions = [
  { nameCn: '大盘数据', nameEn: 'Overall', value: 'overall' },
  { nameCn: '品类', nameEn: 'Genre', value: 'genre' },
  { nameCn: '游戏', nameEn: 'Game', value: 'game' },
];

interface ICompareFilterProps {
  value: string;
  options?: any[];
  onChange: (value: string) => void;
  genreOptions?: any[];
  genreValue?: string;
  changeGenre: (value: string) => void;
}

const CompareFilter = (props: ICompareFilterProps) => {
  const {
    value,
    options = compareOptions,
    onChange,
    genreOptions = [],
    genreValue = '',
    changeGenre
  } = props;
  const { formatMessage } = useIntl();

  const isEn = getLocale() === LANGUAGE_EN;

  const newGenreOptions = useMemo(() => genreOptions.map((item) => {
    const { name_ch, name_en, code } = item;
    return { text: getName(isEn, name_en, name_ch), value: code };
  }), [genreOptions, isEn]);

  return (
    <div className="dbd-benchmark-filter-compare-container">
      <div className="dbd-benchmark-filter-compare-name">
        {formatMessage({ id: 'benchmark_compare_to_filter_name' })}
      </div>
      <Radio.Group value={value} onChange={onChange}>
        {options?.map((item) => {
          const { nameCn, nameEn, value } = item;
          return (
            <Radio key={item.value} name={value} value={item.value}>
              {getName(isEn, nameEn, nameCn)}
            </Radio>
          );
        })}
      </Radio.Group>
      {value === 'genre' && (
        <SingleSelect
          options={newGenreOptions}
          value={genreValue}
          matchButtonWidth
          locale={getLocale()}
          onChange={changeGenre}
          name={formatMessage({ id: 'benchmark_compare_to_filter_genre_button' })}
        />
      )}
    </div>
  );
};

export default CompareFilter;
